import { Component, Input } from "@angular/core";

@Component({
  selector: "app-section-loader",
  templateUrl: "./section-loader.component.html",
})
export class SectionLoaderComponent {
  @Input() loading: boolean;
}
